(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/otp-input.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/otp-input.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef;
const isOnlyDigits = value => /^\d+$/.test(value);
const OtpInput = _ref => {
  let _ref$length = _ref.length,
    length = _ref$length === void 0 ? 4 : _ref$length,
    value = _ref.value,
    onChange = _ref.onChange,
    onComplete = _ref.onComplete,
    onSubmit = _ref.onSubmit;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];
  const inputsRef = useRef([]);
  const otpString = value || internalValue || '';
  const otp = otpString.split('');
  const focusNextInputField = index => {
    if (index < length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };
  const focusPrevInputField = index => {
    if (index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };
  const handleOTPChange = newOtp => {
    const newOtpValue = newOtp.join('');
    setInternalValue(newOtpValue);
    onChange === null || onChange === void 0 || onChange(newOtpValue);
    if (newOtpValue.length === length && isOnlyDigits(newOtpValue)) {
      onComplete === null || onComplete === void 0 || onComplete(newOtpValue);
    }
  };
  const handleInputChange = (event, index) => {
    const value = event.target.value;
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1, value.length);
    if (!value) {
      let nextIndex = index + 1;
      while (newOtp[nextIndex]) {
        newOtp[nextIndex - 1] = newOtp[nextIndex];
        newOtp[nextIndex] = '';
        nextIndex += 1;
      }
      focusPrevInputField(index);
    } else {
      focusNextInputField(index);
    }
    handleOTPChange(newOtp);
  };
  const handlePaste = index => event => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text').slice(0, length - index);
    if (isOnlyDigits(pasteData)) {
      const newOtp = [...otp];
      pasteData.split('').forEach((digit, i) => {
        const inputIndex = index + i;
        newOtp[inputIndex] = digit;
        inputsRef.current[inputIndex].value = digit;
      });
      handleOTPChange(newOtp);
      const focusIndex = Math.min(index + pasteData.length, length - 1);
      inputsRef.current[focusIndex].focus();
    }
  };
  const handleKeyDown = index => event => {
    if (['Spacebar', 'Space', 'ArrowUp', 'ArrowDown'].includes(event.code)) {
      event.preventDefault();
    } else if (event.code === 'ArrowLeft') {
      event.preventDefault();
      focusPrevInputField(index);
    } else if (event.code === 'ArrowRight') {
      event.preventDefault();
      focusNextInputField(index);
    } else if (event.key === otp[index]) {
      event.preventDefault();
      focusNextInputField(index);
    } else if (event.key.length === 1 && !isOnlyDigits(event.key) && !event.metaKey && !event.ctrlKey) {
      event.preventDefault();
    } else if (event.key === 'Backspace' && !otp[index] && index > 0) {
      event.preventDefault();
      focusPrevInputField(index);
    } else if (event.key === 'Enter' && inputsRef.current.every(input => input === null || input === void 0 ? void 0 : input.value)) {
      event.preventDefault();
      onSubmit();
    }
  };
  return React.createElement("div", {
    className: "otp-input-container"
  }, Array.from({
    length
  }, (_, index) => React.createElement("input", {
    "aria-label": "Eng\xE5ngskod, siffra ".concat(index + 1, " av ").concat(length),
    autoComplete: "off",
    autoFocus: index === 0,
    className: "".concat(otp[index] ? 'otp-input-filled' : ''),
    inputMode: "numeric",
    key: "otp-input-".concat(index) 
    ,
    maxLength: "1",
    onChange: e => handleInputChange(e, index),
    onFocus: e => e.target.select(),
    onKeyDown: handleKeyDown(index),
    onPaste: handlePaste(index),
    onWheel: e => e.target.blur(),
    ref: el => inputsRef.current[index] = el,
    type: "number",
    value: otp[index] || ''
  })));
};
setGlobal('svs.ticketsValidate.components.OtpInput', OtpInput);

 })(window);